<div class="rcp-bg-ul-gray-300 rcp-px-6 rcp-pt-6">
    <app-content-header></app-content-header>
    <div class="rcp-sticky rcp-top-0 rcp-w-full rcp-pt-3">
        <app-navigation [navs]="navs()"></app-navigation>
    </div>
</div>
<!--content route-->
<div class="rcp-px-6 rcp-py-8">
    <router-outlet></router-outlet>
</div>
